/** Message catalogue for features/serials (merged into the global catalogues). Keys: "ser.<area>.<name>". */
export const serEn = {
  'ser.title': 'Serials',
  'ser.page.eyebrow': 'Collection',
  'ser.page.title': 'Serials',
  'ser.page.desc': 'Subscriptions, expected issues, receiving and claims.',
  'ser.kpi.label': 'Serials summary',
  'ser.kpi.active': 'Active subscriptions',
  'ser.kpi.week': 'Expected this week',
  'ser.kpi.late': 'Late issues',
  'ser.kpi.claims': 'Claims outstanding',
  'ser.kpi.missing': 'Missing issues',
  'ser.kpi.expiring': 'Expiring soon',
  'ser.tabs.label': 'Serials sections',
  'ser.tabs.detailLabel': 'Subscription sections',
  'ser.tab.subscriptions': 'Subscriptions',
  'ser.tab.worklist': 'Receiving and claims',
  'ser.tab.issues': 'Issues',
  'ser.tab.routing': 'Routing list',
  'ser.tab.renewal': 'Renewal',
  'ser.tab.prediction': 'Prediction',
  'ser.tab.settings': 'Settings',
  'ser.search': 'Search title, vendor or call number',
  'ser.filter.library': 'Library',
  'ser.filter.allLibraries': 'All libraries',
  'ser.filter.status': 'Subscription status',
  'ser.filter.anyStatus': 'Any status',
  'ser.filter.late': 'Has late issues',
  'ser.col.title': 'Title',
  'ser.col.library': 'Library',
  'ser.col.frequency': 'Frequency',
  'ser.col.status': 'Status',
  'ser.col.next': 'Next expected',
  'ser.col.end': 'Ends',
  'ser.col.received': 'Received',
  'ser.col.issue': 'Issue',
  'ser.col.vendor': 'Vendor',
  'ser.col.expected': 'Expected',
  'ser.col.published': 'Published',
  'ser.col.receivedOn': 'Received on',
  'ser.col.claims': 'Claims',
  'ser.openEnded': 'Open-ended',
  'ser.daysLate': '{days} days late',
  'ser.notes': 'Notes',
  'ser.empty.subsTitle': 'No subscriptions yet',
  'ser.empty.subsBody': 'Create a subscription to start predicting and receiving issues.',
  'ser.empty.filteredTitle': 'No subscriptions match',
  'ser.empty.filteredBody': 'Try clearing the search or filters.',
  'ser.empty.worklistTitle': 'Nothing to action',
  'ser.empty.worklist.LATE': 'No issues are marked late.',
  'ser.empty.worklist.OVERDUE': 'No expected issues are past their date.',
  'ser.empty.worklist.THIS_WEEK': 'No issues are expected in the next 7 days.',
  'ser.empty.worklist.EXPECTED': 'No issues are expected.',
  'ser.empty.worklist.CLAIMED': 'No claims are outstanding.',
  'ser.empty.worklist.MISSING': 'No issues are marked missing.',
  'ser.worklist.filter': 'Worklist filter',
  'ser.worklist.LATE': 'Late',
  'ser.worklist.OVERDUE': 'Overdue',
  'ser.worklist.THIS_WEEK': 'This week',
  'ser.worklist.EXPECTED': 'All expected',
  'ser.worklist.CLAIMED': 'Claimed',
  'ser.worklist.MISSING': 'Missing',
  'ser.worklist.claimSelected': 'Claim {count} selected',
  'ser.freq.DAILY': 'Daily',
  'ser.freq.WEEKLY': 'Weekly',
  'ser.freq.FORTNIGHTLY': 'Fortnightly',
  'ser.freq.MONTHLY': 'Monthly',
  'ser.freq.BIMONTHLY': 'Bimonthly',
  'ser.freq.QUARTERLY': 'Quarterly',
  'ser.freq.SEMIANNUAL': 'Semiannual',
  'ser.freq.ANNUAL': 'Annual',
  'ser.freq.IRREGULAR': 'Irregular',
  'ser.subStatus.ACTIVE': 'Active',
  'ser.subStatus.EXPIRED': 'Expired',
  'ser.subStatus.CLOSED': 'Closed',
  'ser.issueStatus.EXPECTED': 'Expected',
  'ser.issueStatus.ARRIVED': 'Received',
  'ser.issueStatus.LATE': 'Late',
  'ser.issueStatus.MISSING': 'Missing',
  'ser.issueStatus.CLAIMED': 'Claimed',
  'ser.issueStatus.NOT_PUBLISHED': 'Not published',
  'ser.issueStatus.DELETED': 'Deleted',
  'ser.flag.late': '{count} late',
  'ser.flag.claimed': '{count} claimed',
  'ser.flag.missing': '{count} missing',
  'ser.flag.expired': 'Ended',
  'ser.flag.expiring': 'Ends in {days} days',
  'ser.new.button': 'New subscription',
  'ser.new.title': 'New subscription',
  'ser.new.desc': 'Pick the title, set the schedule and numbering, and check the preview.',
  'ser.new.submit': 'Create subscription',
  'ser.new.created': 'Subscription created',
  'ser.f.biblio': 'Catalogue record',
  'ser.f.biblioHint': 'Search the catalogue for the serial title.',
  'ser.f.biblioPlaceholder': 'Title, ISSN or author',
  'ser.f.biblioEmpty': 'No matching records',
  'ser.f.library': 'Library',
  'ser.f.libraryPick': 'Choose a library',
  'ser.f.name': 'Subscription name',
  'ser.f.nameHint': 'Shown in lists, e.g. "Print edition".',
  'ser.f.frequency': 'Frequency',
  'ser.f.graceDays': 'Grace days',
  'ser.f.graceHint': 'Days after the expected date before an issue is late.',
  'ser.f.periodDays': 'Days between issues',
  'ser.f.periodHint': 'Used to continue the series after the listed dates.',
  'ser.f.irregularDates': 'Publication dates',
  'ser.f.irregularHint': 'YYYY-MM-DD, separated by commas or new lines.',
  'ser.f.startDate': 'Subscription start',
  'ser.f.firstIssue': 'First issue date',
  'ser.f.firstIssueHint': 'Date of the first issue to expect.',
  'ser.f.endDate': 'End date',
  'ser.f.renewalDate': 'Renewal date',
  'ser.f.price': 'Price (INR)',
  'ser.f.itemType': 'Item type for received issues',
  'ser.f.itemTypeHint': 'Required to create an item when receiving.',
  'ser.f.itemTypeNone': 'None',
  'ser.f.callNumber': 'Call number',
  'ser.f.generate': 'Issues to generate now',
  'ser.f.generateHint': 'Expected issues created straight away (0 to 100).',
  'ser.f.skipHolidays': 'Skip library closures',
  'ser.f.skipHolidaysHint': 'Move expected dates past closed days.',
  'ser.f.notes': 'Notes',
  'ser.err.required': 'This field is required',
  'ser.err.int': 'Enter a whole number',
  'ser.err.min1': 'Must be 1 or more',
  'ser.err.long': 'Too long (200 characters at most)',
  'ser.err.order': 'End date must not be before the start',
  'ser.err.range': 'Value out of range',
  'ser.err.price': 'Enter an amount such as 1250 or 1250.50',
  'ser.err.dates': 'Use dates like 2026-11-01',
  'ser.err.renewDate': 'The new end date must be after the current one',
  'ser.num.title': 'Numbering pattern',
  'ser.num.format': 'Label format',
  'ser.num.formatHint': 'How each issue is named. Insert tokens below.',
  'ser.num.tokens': 'Insert token',
  'ser.num.x': 'Volume (x)',
  'ser.num.xHint': 'Next volume number',
  'ser.num.y': 'Issue (y)',
  'ser.num.yHint': 'Next issue number',
  'ser.num.z': 'Running count (z)',
  'ser.num.zHint': 'Issues generated so far plus one',
  'ser.num.yMax': 'Issues per volume',
  'ser.num.yMaxHint': 'Volume increases after this issue number',
  'ser.num.yEvery': 'Advance issue every',
  'ser.num.yEveryHint': 'Leave blank for every issue',
  'ser.num.xEvery': 'Advance volume every',
  'ser.num.xEveryHint': 'Total issues per volume (optional)',
  'ser.predict.title': 'Prediction preview',
  'ser.predict.desc': 'The next {count} issues this schedule would produce. Nothing is saved.',
  'ser.predict.subDesc': 'What the next issues will look like, continuing from the current counters.',
  'ser.predict.count': 'Issues to preview',
  'ser.predict.idleTitle': 'Preview appears here',
  'ser.predict.idleBody': 'Set a valid start date and numbering to see the schedule.',
  'ser.predict.emptyTitle': 'No issues predicted',
  'ser.predict.emptyBody': 'Check the frequency and dates.',
  'ser.predict.after': 'After these, the next issue is Vol. {x}, No. {y} (count {z}), expected {date}.',
  'ser.detail.next': 'Next expected',
  'ser.detail.received': 'Received',
  'ser.detail.pending': 'Awaiting',
  'ser.detail.record': 'Catalogue record',
  'ser.detail.back': 'Back to serials',
  'ser.detail.notFound': 'Subscription not found',
  'ser.detail.notFoundBody': 'It may have been deleted, or the link is wrong.',
  'ser.issues.view': 'Issues view',
  'ser.issues.grid': 'Calendar',
  'ser.issues.table': 'Table',
  'ser.issues.generate': 'Generate next',
  'ser.issues.generateCount': 'Number of issues to generate',
  'ser.issues.generated': '{count} expected issues generated',
  'ser.grid.legend': 'Status colours',
  'ser.grid.emptyTitle': 'No issues yet',
  'ser.grid.emptyBody': 'Generate the next expected issues to start receiving.',
  'ser.grid.volume': 'Vol. {n}',
  'ser.grid.noVolume': 'No volume',
  'ser.grid.undated': 'Undated',
  'ser.action.receive': 'Receive',
  'ser.action.claim': 'Claim from vendor',
  'ser.action.slip': 'Routing slip',
  'ser.action.missing': 'Mark missing',
  'ser.action.notPublished': 'Mark not published',
  'ser.action.expected': 'Mark expected again',
  'ser.action.none': 'No actions available',
  'ser.action.menu': 'Actions for {label}',
  'ser.receive.title': 'Receive issue',
  'ser.receive.date': 'Received on',
  'ser.receive.createItem': 'Create an item for this issue',
  'ser.receive.createItemHint': 'Uses the library, type and call number of the subscription.',
  'ser.receive.barcode': 'Barcode',
  'ser.receive.barcodeHint': 'Leave blank to assign automatically.',
  'ser.receive.accession': 'Accession number',
  'ser.receive.copy': 'Copy number',
  'ser.receive.publicNote': 'Public note',
  'ser.receive.submit': 'Receive issue',
  'ser.receive.done': 'Received {label}',
  'ser.receive.next': 'Next expected: {label}',
  'ser.status.title.MISSING': 'Mark issue missing',
  'ser.status.title.NOT_PUBLISHED': 'Mark issue not published',
  'ser.status.title.EXPECTED': 'Mark issue expected again',
  'ser.status.body.MISSING': 'The issue will be listed as missing and can still be claimed or received later.',
  'ser.status.body.NOT_PUBLISHED': 'Use this when the publisher skipped the issue. It will no longer be expected.',
  'ser.status.body.EXPECTED': 'The issue returns to the expected list.',
  'ser.status.confirm.MISSING': 'Mark missing',
  'ser.status.confirm.NOT_PUBLISHED': 'Mark not published',
  'ser.status.confirm.EXPECTED': 'Mark expected',
  'ser.status.done.MISSING': '{label} marked missing',
  'ser.status.done.NOT_PUBLISHED': '{label} marked not published',
  'ser.status.done.EXPECTED': '{label} is expected again',
  'ser.claim.title': 'Claim {count} issues',
  'ser.claim.desc': 'Records a claim for each issue and prepares the vendor letters.',
  'ser.claim.more': 'and {count} more',
  'ser.claim.submit': 'Claim',
  'ser.claim.resultTitle': '{count} issues claimed',
  'ser.claim.resultDesc': 'Copy or print the letters for your vendors.',
  'ser.claim.noLetters': 'No letters were generated.',
  'ser.claim.noVendor': 'No vendor',
  'ser.claim.copy': 'Copy letter',
  'ser.slip.title': 'Routing slip',
  'ser.slip.received': 'received {date}',
  'ser.slip.empty': 'No recipients',
  'ser.slip.emptyBody': 'Add patrons on the Routing list tab.',
  'ser.routing.title': 'Routing list',
  'ser.routing.desc': 'Patrons who read each issue in turn. Order matters.',
  'ser.routing.emptyTitle': 'No one on the routing list',
  'ser.routing.emptyBody': 'Search for a patron above to add the first recipient.',
  'ser.routing.added': '{name} added to the routing list',
  'ser.routing.duplicate': 'This patron is already on the list.',
  'ser.routing.up': 'Move {name} up',
  'ser.routing.down': 'Move {name} down',
  'ser.routing.remove': 'Remove {name}',
  'ser.routing.removeTitle': 'Remove {name}?',
  'ser.routing.removeBody': 'They will no longer appear on routing slips.',
  'ser.renew.title': 'Renew subscription',
  'ser.renew.button': 'Renew',
  'ser.renew.current': 'Currently ends {date}',
  'ser.renew.newEnd': 'New end date',
  'ser.renew.nextRenewalHint': 'When to review the next renewal.',
  'ser.renew.submit': 'Renew subscription',
  'ser.renew.done': 'Renewed until {date}',
  'ser.renew.endsIn': 'Ends in {days} days',
  'ser.renew.endedAgo': 'Ended {days} days ago',
  'ser.renew.history': 'Renewal history',
  'ser.renew.emptyTitle': 'Not renewed yet',
  'ser.renew.emptyBody': 'Renewals appear here with their price and dates.',
  'ser.renew.to': 'to',
  'ser.settings.saved': 'Subscription saved',
  'ser.settings.numberingNote': 'Changing the counters affects issues generated from now on, not existing ones.',
  'ser.settings.danger': 'Delete subscription',
  'ser.settings.dangerBody': 'Only possible while no issue has been received. Close the subscription instead to keep its history.',
  'ser.settings.delete': 'Delete subscription',
  'ser.settings.deleteTitle': 'Delete this subscription?',
  'ser.settings.deleteBody': 'Its expected issues and routing list are removed. This cannot be undone.',
  'ser.settings.deleted': 'Subscription deleted',
} as const;

export const serHi: Record<keyof typeof serEn, string> = {
  'ser.title': 'सीरियल्स',
  'ser.page.eyebrow': 'संग्रह',
  'ser.page.title': 'सीरियल्स',
  'ser.page.desc': 'सदस्यताएँ, अपेक्षित अंक, प्राप्ति और दावे।',
  'ser.kpi.label': 'सीरियल्स सारांश',
  'ser.kpi.active': 'सक्रिय सदस्यताएँ',
  'ser.kpi.week': 'इस सप्ताह अपेक्षित',
  'ser.kpi.late': 'विलंबित अंक',
  'ser.kpi.claims': 'लंबित दावे',
  'ser.kpi.missing': 'गुम अंक',
  'ser.kpi.expiring': 'जल्द समाप्त',
  'ser.tabs.label': 'सीरियल्स अनुभाग',
  'ser.tabs.detailLabel': 'सदस्यता अनुभाग',
  'ser.tab.subscriptions': 'सदस्यताएँ',
  'ser.tab.worklist': 'प्राप्ति और दावे',
  'ser.tab.issues': 'अंक',
  'ser.tab.routing': 'रूटिंग सूची',
  'ser.tab.renewal': 'नवीनीकरण',
  'ser.tab.prediction': 'पूर्वानुमान',
  'ser.tab.settings': 'सेटिंग्स',
  'ser.search': 'शीर्षक, विक्रेता या कॉल नंबर खोजें',
  'ser.filter.library': 'पुस्तकालय',
  'ser.filter.allLibraries': 'सभी पुस्तकालय',
  'ser.filter.status': 'सदस्यता स्थिति',
  'ser.filter.anyStatus': 'कोई भी स्थिति',
  'ser.filter.late': 'विलंबित अंक हैं',
  'ser.col.title': 'शीर्षक',
  'ser.col.library': 'पुस्तकालय',
  'ser.col.frequency': 'आवृत्ति',
  'ser.col.status': 'स्थिति',
  'ser.col.next': 'अगला अपेक्षित',
  'ser.col.end': 'समाप्ति',
  'ser.col.received': 'प्राप्त',
  'ser.col.issue': 'अंक',
  'ser.col.vendor': 'विक्रेता',
  'ser.col.expected': 'अपेक्षित',
  'ser.col.published': 'प्रकाशित',
  'ser.col.receivedOn': 'प्राप्ति तिथि',
  'ser.col.claims': 'दावे',
  'ser.openEnded': 'अनिश्चित अवधि',
  'ser.daysLate': '{days} दिन विलंब',
  'ser.notes': 'टिप्पणियाँ',
  'ser.empty.subsTitle': 'अभी कोई सदस्यता नहीं',
  'ser.empty.subsBody': 'अंकों का पूर्वानुमान और प्राप्ति शुरू करने के लिए सदस्यता बनाएँ।',
  'ser.empty.filteredTitle': 'कोई सदस्यता मेल नहीं खाती',
  'ser.empty.filteredBody': 'खोज या फ़िल्टर हटाकर देखें।',
  'ser.empty.worklistTitle': 'कोई कार्य शेष नहीं',
  'ser.empty.worklist.LATE': 'कोई अंक विलंबित चिह्नित नहीं है।',
  'ser.empty.worklist.OVERDUE': 'कोई अपेक्षित अंक तिथि से आगे नहीं है।',
  'ser.empty.worklist.THIS_WEEK': 'अगले 7 दिनों में कोई अंक अपेक्षित नहीं है।',
  'ser.empty.worklist.EXPECTED': 'कोई अंक अपेक्षित नहीं है।',
  'ser.empty.worklist.CLAIMED': 'कोई दावा लंबित नहीं है।',
  'ser.empty.worklist.MISSING': 'कोई अंक गुम चिह्नित नहीं है।',
  'ser.worklist.filter': 'कार्यसूची फ़िल्टर',
  'ser.worklist.LATE': 'विलंबित',
  'ser.worklist.OVERDUE': 'अतिदेय',
  'ser.worklist.THIS_WEEK': 'इस सप्ताह',
  'ser.worklist.EXPECTED': 'सभी अपेक्षित',
  'ser.worklist.CLAIMED': 'दावा किया',
  'ser.worklist.MISSING': 'गुम',
  'ser.worklist.claimSelected': '{count} चयनित का दावा करें',
  'ser.freq.DAILY': 'दैनिक',
  'ser.freq.WEEKLY': 'साप्ताहिक',
  'ser.freq.FORTNIGHTLY': 'पाक्षिक',
  'ser.freq.MONTHLY': 'मासिक',
  'ser.freq.BIMONTHLY': 'द्वैमासिक',
  'ser.freq.QUARTERLY': 'त्रैमासिक',
  'ser.freq.SEMIANNUAL': 'अर्धवार्षिक',
  'ser.freq.ANNUAL': 'वार्षिक',
  'ser.freq.IRREGULAR': 'अनियमित',
  'ser.subStatus.ACTIVE': 'सक्रिय',
  'ser.subStatus.EXPIRED': 'समाप्त',
  'ser.subStatus.CLOSED': 'बंद',
  'ser.issueStatus.EXPECTED': 'अपेक्षित',
  'ser.issueStatus.ARRIVED': 'प्राप्त',
  'ser.issueStatus.LATE': 'विलंबित',
  'ser.issueStatus.MISSING': 'गुम',
  'ser.issueStatus.CLAIMED': 'दावा किया',
  'ser.issueStatus.NOT_PUBLISHED': 'अप्रकाशित',
  'ser.issueStatus.DELETED': 'हटाया गया',
  'ser.flag.late': '{count} विलंबित',
  'ser.flag.claimed': '{count} दावे',
  'ser.flag.missing': '{count} गुम',
  'ser.flag.expired': 'समाप्त',
  'ser.flag.expiring': '{days} दिन में समाप्त',
  'ser.new.button': 'नई सदस्यता',
  'ser.new.title': 'नई सदस्यता',
  'ser.new.desc': 'शीर्षक चुनें, अनुसूची और क्रमांकन तय करें, और पूर्वावलोकन देखें।',
  'ser.new.submit': 'सदस्यता बनाएँ',
  'ser.new.created': 'सदस्यता बनाई गई',
  'ser.f.biblio': 'सूची रिकॉर्ड',
  'ser.f.biblioHint': 'सीरियल शीर्षक के लिए सूची में खोजें।',
  'ser.f.biblioPlaceholder': 'शीर्षक, ISSN या लेखक',
  'ser.f.biblioEmpty': 'कोई मिलता रिकॉर्ड नहीं',
  'ser.f.library': 'पुस्तकालय',
  'ser.f.libraryPick': 'पुस्तकालय चुनें',
  'ser.f.name': 'सदस्यता नाम',
  'ser.f.nameHint': 'सूचियों में दिखता है, जैसे "मुद्रित संस्करण"।',
  'ser.f.frequency': 'आवृत्ति',
  'ser.f.graceDays': 'अनुग्रह दिन',
  'ser.f.graceHint': 'अपेक्षित तिथि के बाद कितने दिन में अंक विलंबित माना जाए।',
  'ser.f.periodDays': 'अंकों के बीच दिन',
  'ser.f.periodHint': 'सूचीबद्ध तिथियों के बाद श्रृंखला जारी रखने के लिए।',
  'ser.f.irregularDates': 'प्रकाशन तिथियाँ',
  'ser.f.irregularHint': 'YYYY-MM-DD, अल्पविराम या नई पंक्ति से अलग करें।',
  'ser.f.startDate': 'सदस्यता आरंभ',
  'ser.f.firstIssue': 'पहले अंक की तिथि',
  'ser.f.firstIssueHint': 'पहले अपेक्षित अंक की तिथि।',
  'ser.f.endDate': 'समाप्ति तिथि',
  'ser.f.renewalDate': 'नवीनीकरण तिथि',
  'ser.f.price': 'मूल्य (INR)',
  'ser.f.itemType': 'प्राप्त अंकों का आइटम प्रकार',
  'ser.f.itemTypeHint': 'प्राप्ति पर आइटम बनाने के लिए आवश्यक।',
  'ser.f.itemTypeNone': 'कोई नहीं',
  'ser.f.callNumber': 'कॉल नंबर',
  'ser.f.generate': 'अभी बनाए जाने वाले अंक',
  'ser.f.generateHint': 'तुरंत बनने वाले अपेक्षित अंक (0 से 100)।',
  'ser.f.skipHolidays': 'पुस्तकालय बंदी छोड़ें',
  'ser.f.skipHolidaysHint': 'अपेक्षित तिथियाँ बंद दिनों के बाद ले जाएँ।',
  'ser.f.notes': 'टिप्पणियाँ',
  'ser.err.required': 'यह फ़ील्ड आवश्यक है',
  'ser.err.int': 'पूर्ण संख्या दर्ज करें',
  'ser.err.min1': '1 या अधिक होना चाहिए',
  'ser.err.long': 'बहुत लंबा (अधिकतम 200 अक्षर)',
  'ser.err.order': 'समाप्ति तिथि आरंभ से पहले नहीं हो सकती',
  'ser.err.range': 'मान सीमा से बाहर है',
  'ser.err.price': '1250 या 1250.50 जैसी राशि दर्ज करें',
  'ser.err.dates': '2026-11-01 जैसी तिथियाँ उपयोग करें',
  'ser.err.renewDate': 'नई समाप्ति तिथि वर्तमान से बाद की होनी चाहिए',
  'ser.num.title': 'क्रमांकन पैटर्न',
  'ser.num.format': 'लेबल प्रारूप',
  'ser.num.formatHint': 'प्रत्येक अंक का नाम कैसे बने। नीचे से टोकन जोड़ें।',
  'ser.num.tokens': 'टोकन जोड़ें',
  'ser.num.x': 'खंड (x)',
  'ser.num.xHint': 'अगला खंड क्रमांक',
  'ser.num.y': 'अंक (y)',
  'ser.num.yHint': 'अगला अंक क्रमांक',
  'ser.num.z': 'कुल गिनती (z)',
  'ser.num.zHint': 'अब तक बने अंक जमा एक',
  'ser.num.yMax': 'प्रति खंड अंक',
  'ser.num.yMaxHint': 'इस अंक के बाद खंड बढ़ता है',
  'ser.num.yEvery': 'अंक बढ़ाएँ हर',
  'ser.num.yEveryHint': 'हर अंक के लिए खाली छोड़ें',
  'ser.num.xEvery': 'खंड बढ़ाएँ हर',
  'ser.num.xEveryHint': 'प्रति खंड कुल अंक (वैकल्पिक)',
  'ser.predict.title': 'पूर्वानुमान पूर्वावलोकन',
  'ser.predict.desc': 'यह अनुसूची अगले {count} अंक बनाएगी। कुछ भी सहेजा नहीं जाता।',
  'ser.predict.subDesc': 'वर्तमान काउंटर से आगे अगले अंक कैसे दिखेंगे।',
  'ser.predict.count': 'पूर्वावलोकन के अंक',
  'ser.predict.idleTitle': 'पूर्वावलोकन यहाँ दिखेगा',
  'ser.predict.idleBody': 'अनुसूची देखने के लिए मान्य आरंभ तिथि और क्रमांकन दें।',
  'ser.predict.emptyTitle': 'कोई अंक अनुमानित नहीं',
  'ser.predict.emptyBody': 'आवृत्ति और तिथियाँ जाँचें।',
  'ser.predict.after': 'इनके बाद अगला अंक खंड {x}, अंक {y} (गिनती {z}) है, अपेक्षित {date}।',
  'ser.detail.next': 'अगला अपेक्षित',
  'ser.detail.received': 'प्राप्त',
  'ser.detail.pending': 'प्रतीक्षित',
  'ser.detail.record': 'सूची रिकॉर्ड',
  'ser.detail.back': 'सीरियल्स पर वापस',
  'ser.detail.notFound': 'सदस्यता नहीं मिली',
  'ser.detail.notFoundBody': 'यह हटाई जा चुकी हो सकती है, या लिंक गलत है।',
  'ser.issues.view': 'अंक दृश्य',
  'ser.issues.grid': 'कैलेंडर',
  'ser.issues.table': 'तालिका',
  'ser.issues.generate': 'अगले बनाएँ',
  'ser.issues.generateCount': 'बनाए जाने वाले अंकों की संख्या',
  'ser.issues.generated': '{count} अपेक्षित अंक बनाए गए',
  'ser.grid.legend': 'स्थिति रंग',
  'ser.grid.emptyTitle': 'अभी कोई अंक नहीं',
  'ser.grid.emptyBody': 'प्राप्ति शुरू करने के लिए अगले अपेक्षित अंक बनाएँ।',
  'ser.grid.volume': 'खंड {n}',
  'ser.grid.noVolume': 'खंड नहीं',
  'ser.grid.undated': 'तिथि रहित',
  'ser.action.receive': 'प्राप्त करें',
  'ser.action.claim': 'विक्रेता से दावा करें',
  'ser.action.slip': 'रूटिंग पर्ची',
  'ser.action.missing': 'गुम चिह्नित करें',
  'ser.action.notPublished': 'अप्रकाशित चिह्नित करें',
  'ser.action.expected': 'फिर अपेक्षित करें',
  'ser.action.none': 'कोई कार्य उपलब्ध नहीं',
  'ser.action.menu': '{label} के कार्य',
  'ser.receive.title': 'अंक प्राप्त करें',
  'ser.receive.date': 'प्राप्ति तिथि',
  'ser.receive.createItem': 'इस अंक के लिए आइटम बनाएँ',
  'ser.receive.createItemHint': 'सदस्यता का पुस्तकालय, प्रकार और कॉल नंबर उपयोग होगा।',
  'ser.receive.barcode': 'बारकोड',
  'ser.receive.barcodeHint': 'स्वतः देने के लिए खाली छोड़ें।',
  'ser.receive.accession': 'प्रवेश संख्या',
  'ser.receive.copy': 'प्रति संख्या',
  'ser.receive.publicNote': 'सार्वजनिक टिप्पणी',
  'ser.receive.submit': 'अंक प्राप्त करें',
  'ser.receive.done': '{label} प्राप्त हुआ',
  'ser.receive.next': 'अगला अपेक्षित: {label}',
  'ser.status.title.MISSING': 'अंक गुम चिह्नित करें',
  'ser.status.title.NOT_PUBLISHED': 'अंक अप्रकाशित चिह्नित करें',
  'ser.status.title.EXPECTED': 'अंक फिर अपेक्षित करें',
  'ser.status.body.MISSING': 'अंक गुम सूचीबद्ध होगा और बाद में दावा या प्राप्त किया जा सकता है।',
  'ser.status.body.NOT_PUBLISHED': 'प्रकाशक ने अंक छोड़ा हो तो उपयोग करें। यह अब अपेक्षित नहीं रहेगा।',
  'ser.status.body.EXPECTED': 'अंक अपेक्षित सूची में लौट जाएगा।',
  'ser.status.confirm.MISSING': 'गुम चिह्नित करें',
  'ser.status.confirm.NOT_PUBLISHED': 'अप्रकाशित चिह्नित करें',
  'ser.status.confirm.EXPECTED': 'अपेक्षित करें',
  'ser.status.done.MISSING': '{label} गुम चिह्नित',
  'ser.status.done.NOT_PUBLISHED': '{label} अप्रकाशित चिह्नित',
  'ser.status.done.EXPECTED': '{label} फिर अपेक्षित',
  'ser.claim.title': '{count} अंकों का दावा करें',
  'ser.claim.desc': 'प्रत्येक अंक का दावा दर्ज करता है और विक्रेता पत्र तैयार करता है।',
  'ser.claim.more': 'और {count} अन्य',
  'ser.claim.submit': 'दावा करें',
  'ser.claim.resultTitle': '{count} अंकों का दावा किया गया',
  'ser.claim.resultDesc': 'अपने विक्रेताओं के लिए पत्र कॉपी या प्रिंट करें।',
  'ser.claim.noLetters': 'कोई पत्र नहीं बना।',
  'ser.claim.noVendor': 'कोई विक्रेता नहीं',
  'ser.claim.copy': 'पत्र कॉपी करें',
  'ser.slip.title': 'रूटिंग पर्ची',
  'ser.slip.received': 'प्राप्त {date}',
  'ser.slip.empty': 'कोई प्राप्तकर्ता नहीं',
  'ser.slip.emptyBody': 'रूटिंग सूची टैब पर सदस्य जोड़ें।',
  'ser.routing.title': 'रूटिंग सूची',
  'ser.routing.desc': 'सदस्य जो हर अंक बारी-बारी से पढ़ते हैं। क्रम महत्वपूर्ण है।',
  'ser.routing.emptyTitle': 'रूटिंग सूची में कोई नहीं',
  'ser.routing.emptyBody': 'पहला प्राप्तकर्ता जोड़ने के लिए ऊपर सदस्य खोजें।',
  'ser.routing.added': '{name} रूटिंग सूची में जोड़े गए',
  'ser.routing.duplicate': 'यह सदस्य पहले से सूची में है।',
  'ser.routing.up': '{name} को ऊपर ले जाएँ',
  'ser.routing.down': '{name} को नीचे ले जाएँ',
  'ser.routing.remove': '{name} को हटाएँ',
  'ser.routing.removeTitle': '{name} को हटाएँ?',
  'ser.routing.removeBody': 'वे अब रूटिंग पर्चियों पर नहीं दिखेंगे।',
  'ser.renew.title': 'सदस्यता नवीनीकृत करें',
  'ser.renew.button': 'नवीनीकरण',
  'ser.renew.current': 'वर्तमान समाप्ति {date}',
  'ser.renew.newEnd': 'नई समाप्ति तिथि',
  'ser.renew.nextRenewalHint': 'अगला नवीनीकरण कब देखना है।',
  'ser.renew.submit': 'सदस्यता नवीनीकृत करें',
  'ser.renew.done': '{date} तक नवीनीकृत',
  'ser.renew.endsIn': '{days} दिन में समाप्त',
  'ser.renew.endedAgo': '{days} दिन पहले समाप्त',
  'ser.renew.history': 'नवीनीकरण इतिहास',
  'ser.renew.emptyTitle': 'अभी नवीनीकृत नहीं',
  'ser.renew.emptyBody': 'नवीनीकरण मूल्य और तिथियों सहित यहाँ दिखते हैं।',
  'ser.renew.to': 'से',
  'ser.settings.saved': 'सदस्यता सहेजी गई',
  'ser.settings.numberingNote': 'काउंटर बदलने का प्रभाव अब से बनने वाले अंकों पर होगा, मौजूदा पर नहीं।',
  'ser.settings.danger': 'सदस्यता हटाएँ',
  'ser.settings.dangerBody': 'केवल तब संभव है जब कोई अंक प्राप्त न हुआ हो। इतिहास रखने के लिए इसके बजाय सदस्यता बंद करें।',
  'ser.settings.delete': 'सदस्यता हटाएँ',
  'ser.settings.deleteTitle': 'यह सदस्यता हटाएँ?',
  'ser.settings.deleteBody': 'इसके अपेक्षित अंक और रूटिंग सूची हट जाएँगे। इसे पूर्ववत नहीं किया जा सकता।',
  'ser.settings.deleted': 'सदस्यता हटाई गई',
};
